import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";



// Services
import { ApiService } from "app/shared/services/api/api.service";

//Models
import { User } from "app/shared/models/user";



@Injectable()
export class UserService {

    private users: User[];
    private readonly userEndpoint = '/api/Users';


    constructor(
        private apiService: ApiService,
    ) { }



    setUsers(users: User[]) {
        this.users = users;
    }

    getUsers(): Observable<User[]> {


        if (this.users == null) {
            return this.apiService.Get(this.userEndpoint);
        }


        else {
            return Observable.of(this.users);
        }

    }



}



// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/users/user.service.ts